export default __webpack_public_path__ + "static/media/wonderland-pepe.46410f27.jpeg";